// @ts-nocheck
/**
 * メインNPC: ヴェルデ
 * 大陸情報局の窓口担当
 */

export const VERDE = {
  id: 'verde',
  name: 'ヴェルデ',
  role: '大陸情報局窓口',
  appearance: '眼鏡の青年。きっちりした服装、常にメモ帳',
  personality: '冷静沈着、データ重視、感情を見せない',
  icon: '👓',
  quotes: {
    greeting: 'いらっしゃいませ。本日の情勢をお伝えします',
    advice: '各地域の利権に分散投資することで、リスクを抑えられます',
    disclaimer: '投資判断は自己責任でお願いします',
    purchase: 'ご購入ありがとうございます。運用状況はポートフォリオでご確認ください',
    sell: '売却を承りました。手数料を差し引いた金額をお渡しします',
    noMoney: '申し訳ございません。残高が不足しております',
    // 本音（稀に表示）
    honest: [
      '...まあ、賭けですよ。合法的なね',
      '我々は手数料をいただくだけです。損はしません',
      '情報を持つ者が勝つ。それがこの世界です',
      '感情で動くと、損をしますよ',
    ],
  },
};

/**
 * ヴェルデのセリフを取得
 * @param {string} situation - 状況キー
 * @returns {string} セリフ
 */
export function getVerdeQuote(situation) {
  if (situation === 'honest') {
    // 本音はランダムで1つ
    const honestQuotes = VERDE.quotes.honest;
    return honestQuotes[Math.floor(Math.random() * honestQuotes.length)];
  }
  return VERDE.quotes[situation] || VERDE.quotes.greeting;
}

/**
 * ヴェルデの本音を表示するかどうか（5%の確率）
 */
export function shouldShowHonestQuote() {
  return Math.random() < 0.05;
}
